module.exports = __webpack_public_path__ + "static/img/jiankong.3b99973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taidi/jiankong.png
// module id = vc0r
// module chunks = 19